/**
 * In-app path to a specific casino game with a `from` back-link, e.g.
 * `/casino/play/715104?from=/profile/bonuses`. Freespin Play CTAs and the eligible-game
 * tiles open the concrete game instead of the casino landing page.
 */
export const buildCasinoGamePath = (casinoPath, casinoGamePath, gameId) => {
  const url = new URL(`${window.location.origin}${casinoPath}/${casinoGamePath}/${gameId}`);
  url.searchParams.set('from', window.location.pathname + window.location.search);
  return url.pathname + url.search;
};

/**
 * First eligible game id of a mapped freespin (mapFreeSpinForUi shape), used to open
 * the game from a Play CTA. Returns undefined when the freespin has no game configured.
 */
export const getFreespinGameId = row => row?.freeSpin?.casinoLimit?.gameIds?.[0];
